/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import ToolTip from "../../../components/ToolTip/ToolTip";
import DataComponent from "../../../components/DataComponent";
import {
  getVacationsLeavesManager,
  modifyVacationsLeavesManager,
} from "../../../apis/vacation/vacation-leave-manager";
import useForm from "../../../hooks/useForm";
import { dateToFormat } from "../../../utils/date";
import { isEmpty, isEqual } from "lodash";
import DatePicker from "../../../components/DatePicker";
import systemAlert from "../../../utils/systemAlert";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";
import { isAdminCompany } from "../../../utils/auth";

const OCCURRENCE_STANDARD = [
  { label: "회계연도", value: "annualYear" },
  { label: "입사일", value: "joinDate" },
];

const DECIMAL_POINT_PROCESS = [
  { label: "반올림", value: "off" },
  { label: "올림", value: "up" },
  { label: "버림", value: "down" },
];
const USE_LIMIT = [
  { label: "제한없음", value: "unlimited" },
  { label: "잔여 연차 내에서만 사용", value: "limited" },
];
const OCCURRENCE_STANDARD_LESS_1YEAR = [
  { label: "한 달 만근 시마다", value: "monthly" },
  { label: "만근 가정 입사시", value: "annual" },
];

const VacationStandard = (props) => {
  const history = useHistory()
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions,
  }));
  const [vacationList, setVacationList] = useState([]);
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'VACATION_LEAVE_MANAGEMENT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "VACATION_LEAVE_MANAGEMENT")
      }
    }
  }, [permissions])

  const onChange = (params, field, idx) => {
    const transData = vacationList.map((vacation, index) => {
      if (index === idx) {
        return {
          yearNum: vacation.yearNum,
          leaveNum: params.leaveNum,
        };
      }
      return vacation;
    });

    setVacationList(transData);
  };

  const _submit = (form) => {
    const params = {
      leaveCreateControl: form.leaveCreateControl,
      leaveDecimalControl: form.leaveDecimalControl,
      leaveUseLimit: form.leaveUseLimit,
      leaveCreateAtEntry: form.leaveCreateAtEntry,
      leaveCountEachYear: form.leaveCountEachYear,
      planStartDate: `${form.dates[0]} 00:00:00`,
      planEndDate: `${form.dates[1]} 23:59:59`,
    };

    systemAlert('연차 기준을 수정하시겠습니까?\n\n연차 기준을 변경하면 익일 기준에 따라 재계산되어 원하시는 결과와 다를 수 있습니다.\n\n 이러한 경우 필요한 부분은 직접 수정해주셔야 합니다.', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            modifyVacationsLeavesManager(params)
              .then((res) => { })
              .catch((err) => { });
          }
        }
      ]
    })
  };

  const { form, originForm, setForm, handleOnChange, handleSubmit, setOriginForm } = useForm(
    {
      leaveCreateControl: "",
      leaveDecimalControl: "",
      leaveUseLimit: "",
      leaveCreateAtEntry: "",
      leaveCountEachYear: [],
      dates: [],
    },
    _submit,
    {}
  );

  useEffect(() => {
    if (!isEmpty(vacationList)) {
      setForm({
        ...form,
        leaveCountEachYear: vacationList,
      });
    }
  }, [vacationList]);

  useEffect(() => {
    submit();
  }, []);

  const submit = () => {
    getVacationsLeavesManager()
      .then((res) => {
        setForm({
          leaveCreateControl: res.data.leaveCreateControl,
          leaveDecimalControl: res.data.leaveDecimalControl,
          leaveUseLimit: res.data.leaveUseLimit,
          leaveCreateAtEntry: res.data.leaveCreateAtEntry,
          dates: [
            dateToFormat(res.data.planStartDate, "YYYY-MM-DD"),
            dateToFormat(res.data.planEndDate, "YYYY-MM-DD"),
          ],
          leaveCountEachYear: res.data.leaveCountEachYear,
        });
        setVacationList(res.data.leaveCountEachYear);
        setOriginForm({
          leaveCreateControl: res.data.leaveCreateControl,
          leaveDecimalControl: res.data.leaveDecimalControl,
          leaveUseLimit: res.data.leaveUseLimit,
          leaveCreateAtEntry: res.data.leaveCreateAtEntry,
          dates: [
            dateToFormat(res.data.planStartDate, "YYYY-MM-DD"),
            dateToFormat(res.data.planEndDate, "YYYY-MM-DD"),
          ],
          leaveCountEachYear: res.data.leaveCountEachYear,
        })
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const headerButton = [
    {
      label: "저장하기",
      action: handleSubmit,
      disabled: isEqual(form, originForm)
    },
  ];

  return (
    !isEmpty(targetPermission) && (
      <div className="vacation-standard">
        <PageHeader title={"연차 기준 관리"} buttons={targetPermission.level > 1 ? headerButton : []} />
        <div className="vacation-standard-wrap">
          <div className="vacation-form">
            <p className="form-title">연차 발생 기준</p>
            <div className="form-container">
              {OCCURRENCE_STANDARD.map(({ label, value }, idx) => (
                <label className="radio-label" key={idx}>
                  <input
                    className="radio-input"
                    type="radio"
                    name="leaveCreateControl"
                    value={value}
                    checked={form.leaveCreateControl === value}
                    onChange={handleOnChange}
                    // disabled={targetPermission.level <= 1}
                    disabled={isAdminCompany() ? false : true}
                  />
                  {label}
                </label>
              ))}
            </div>
            <p className="form-title">연차발생 소수점 처리</p>
            <ToolTip
              position="bottom"
              tooltiptext="입사 2년차 사원의 경우 전년도 입사일 기준 (근무일수/365)*15 로 계산되기에 소수점으로 연차가 발생 될 수 있습니다. 해당 기능으로 소수점을 처리하는 방법을 정할 수 있습니다."
            />
            <div className="form-container">
              {DECIMAL_POINT_PROCESS.map(({ label, value }, idx) => (
                <label className="radio-label" key={idx}>
                  <input
                    className="radio-input"
                    type="radio"
                    name="leaveDecimalControl"
                    value={value}
                    checked={form.leaveDecimalControl === value}
                    onChange={handleOnChange}
                    disabled={targetPermission.level <= 1}
                  />
                  {label}
                </label>
              ))}
            </div>
            <p className="form-title">연차 사용 한도</p>
            <div className="form-container">
              {USE_LIMIT.map(({ label, value }, idx) => (
                <label className="radio-label" key={idx}>
                  <input
                    className="radio-input"
                    type="radio"
                    name="leaveUseLimit"
                    value={value}
                    checked={form.leaveUseLimit === value}
                    onChange={handleOnChange}
                    disabled={targetPermission.level <= 1}
                  />
                  {label}
                </label>
              ))}
            </div>
            <p className="form-title">1년 미만 연차 발생 기준</p>
            <div className="form-container">
              {OCCURRENCE_STANDARD_LESS_1YEAR.map(({ label, value }, idx) => (
                <label className="radio-label" key={idx}>
                  <input
                    className="radio-input"
                    type="radio"
                    name="leaveCreateAtEntry"
                    value={value}
                    checked={form.leaveCreateAtEntry === value}
                    onChange={handleOnChange}
                    disabled={targetPermission.level <= 1}
                  />
                  {label}
                </label>
              ))}
            </div>
            <p className="form-title">휴가 계획 작성 기간</p>
            <div className="vacation-plan-picker margin-top-17">
              <DatePicker
                field={{
                  key: "dates",
                  type: "datepicker",
                  options: {
                    mode: "range",
                    dateFormat: "Y-m-d",
                  },
                  value: form.dates,
                }}
                defaultValue={form.dates}
                onChange={handleOnChange}
                disabled={targetPermission.level <= 1}
              />
            </div>
          </div>
          <div className="vacation-list">
            <div className="title-container">
              <p className="form-title" style={{ marginRight: "6px" }}>
                근속연수별
              </p>
              <p className="form-title">연차일수</p>
            </div>
            <div className="list-container">
              <div className="vacation-list-wrap">
                <div className="left-site">
                  {!isEmpty(vacationList) &&
                    vacationList.map((year, idx) => (
                      <div
                        key={idx}
                        style={{ marginTop: idx !== 0 ? "8px" : "0" }}
                      >
                        {idx < 10 && (
                          <DataComponent
                            field={{
                              label: `${year.yearNum}년차`,
                              key: "leaveNum",
                              unit: "일",
                              type: "counter",
                              handleChange: (value, field) =>
                                onChange(value, field, idx),
                            }}
                            data={year.leaveNum}
                            disabled={targetPermission.level <= 1}
                          />
                        )}
                      </div>
                    ))}
                </div>
                <div className="right-site">
                  {!isEmpty(vacationList) &&
                    vacationList.map((year, idx) => (
                      <div
                        key={idx}
                        style={{ marginTop: idx > 10 ? "8px" : "0" }}
                      >
                        {idx >= 10 && (
                          <DataComponent
                            field={{
                              label: `${year.yearNum}년차`,
                              key: "leaveNum",
                              unit: "일",
                              type: "counter",
                              handleChange: (value, field) =>
                                onChange(value, field, idx),
                            }}
                            data={year.leaveNum}
                          />
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
};

export default VacationStandard;
